import React from 'react';

import { useIntl } from 'react-intl';

import { LoyaltyRewards } from 'pages/loyalty/loyalty-rewards';

const LoyaltyRewardsListWidget = () => {
  const { formatMessage } = useIntl();
  return <LoyaltyRewards isWidget title={formatMessage({ id: 'redeemRewards' })} />;
};

export default LoyaltyRewardsListWidget;
